import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/endpoints';
import PageHeader from '../../components/PageHeader';
import { ActivityCard } from '../../components/Cards';
import { Empty, Loading } from '../../components/Ui';
import { Reveal, stagger } from '../../components/Motion';
import { colors } from '../../theme';
import { dateTime, timeAgo } from '../../utils/format';

const MODE_LABEL = { in_person: 'at the workplace', phone: 'on a call', video: 'on video' };

const MyApplicationsPage = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.jobs.myApplications({ limit: 50 })
      .then((res) => setItems(res.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader title="My applications" subtitle={`${items.length} submitted`} />

      {loading ? <Loading /> : !items.length ? (
        <Empty
          emoji="💼"
          title="No applications yet"
          text="Apply to jobs on KAAMWALA and track every application here."
          actionLabel="Browse jobs"
          onAction={() => navigate('/jobs')}
        />
      ) : (
        <div className="grid grid-list">
          {items.map((item, i) => (
            <Reveal key={item._id} delay={stagger(i, 50)}>
              <ActivityCard
                icon="💼"
                title={(item.job && item.job.title) || 'Job'}
                subtitle={`${(item.job && item.job.companyName) || ''} · applied ${timeAgo(item.createdAt)}`}
                amount={item.expectedSalary || 0}
                status={item.status}
                onClick={() => navigate(`/jobs/${item.job && item.job._id}`)}
              />
              {item.interview && item.interview.at ? (
                <div className="card" style={{ marginTop: 8, background: '#EEF6FF', borderColor: '#BFDBFE' }}>
                  <div className="t-title">🗓️ Interview {MODE_LABEL[item.interview.mode] || ''}</div>
                  <div className="t-small">{dateTime(item.interview.at)}</div>
                  {item.interview.place ? <div className="t-small">📍 {item.interview.place}</div> : null}
                  {item.interview.note ? <div className="t-tiny">{item.interview.note}</div> : null}
                  {item.interview.contactPhone || (item.job && item.job.contactPhone) ? (
                    <a className="link-btn" href={`tel:${item.interview.contactPhone || item.job.contactPhone}`}>
                      📞 Call the employer
                    </a>
                  ) : null}
                </div>
              ) : null}
              {item.recruiterNote ? (
                <div
                  style={{
                    background: colors.primaryLight, padding: 12,
                    borderRadius: 12, marginTop: 8,
                  }}
                >
                  <span className="t-small">💬 {item.recruiterNote}</span>
                </div>
              ) : null}
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyApplicationsPage;
